const ONE_TIME_ORDER_STEPS = {
  SELECTION: 'selection',
  PAYMENT: 'payment',
  CONFIRMATION: 'confirmation',
};

const getOrderSubtotal = (orderItems = {}, productPrices = {}, membershipItems = []) => (
  Object.keys(orderItems).reduce((acc, itemId) => {
    const count = orderItems[itemId] || 0;
    const value = (productPrices[itemId] ?? 0) * count;

    if (membershipItems.includes(itemId)) {
      return acc + value;
    }

    return acc;
  }, 0)
);

const getOneTimeOrderTotal = (subtotal = 0, shippingCost = 0, tax = 0) => (
  subtotal + shippingCost + tax
);

const formatPrice = (cents = 0) => {
  const dollars = cents / 100;
  return dollars.toFixed(2);
};

const getOneTimeOrderPlanValue = (plan = {}) => (
  (plan?.unitAmount ?? 0) / 100
);

export {
  ONE_TIME_ORDER_STEPS,
  getOrderSubtotal,
  getOneTimeOrderTotal,
  formatPrice,
  getOneTimeOrderPlanValue,
};
